import React from "react";
import { useDispatch } from "react-redux";
import { OutputConfigSlice } from "../../redux";
import { OutputMappingButtonsBarView } from "./OutputMappingButtonsBar.view";
import { Actions } from "./Types";

/**
 * Responsible for Buttons Bar logic
 */
export const OutputMappingButtonsBar: React.FC = () => {
  const dispatch = useDispatch();

  /**
   * Action to add new config
   */
  const onAddNewConfig = (): void => {
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping(
      {
        status: true,
        action: Actions.CREATE,
        band: Actions.EMPTY,
        configMapId: Actions.EMPTY
      }));
  };

  /**
   * Action on search , set tag search term 
   */
  const onSearchByTag = (value: string): void => {
    dispatch(OutputConfigSlice.actions.setSearchByTagName(value));
  };

  /**
   * Action on show banding toggle , the child items will be displayed on show toggle.
   */
  const onShowBandingsToggle = (value: boolean): void => {
    dispatch(OutputConfigSlice.actions.setShowBandings(value));
  };

  return (
    <OutputMappingButtonsBarView
      onAddNewConfig={onAddNewConfig}
      onShowBandingsToggle={onShowBandingsToggle}
      onSearchByTag={onSearchByTag}
    />
  );
};
